import { atom } from 'jotai';
import type { HomeTabItem } from 'shared/src/api';

/**
 * 현재 활성 홈 탭의 핵심 메타 정보.
 * `render` 같은 스타일 데이터는 제외하고 식별/분류용 필드만 보관해 불필요한 리렌더를 줄인다.
 */
export type ActiveHomeTab = Pick<
  HomeTabItem,
  'id' | 'screen_name' | 'type' | 'name'
>;

/** 현재 보고 있는 홈 탭. 초기화 전/탭 없음 → null */
export const activeHomeTabAtom = atom<ActiveHomeTab | null>(null);
